module.exports = __webpack_public_path__ + "static/media/S1-13-Zibrolttar-cod13.c0356246.png";